<div class="modal-header">
  <h3>Update Fee Vouchers</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  @if (CompanyForm) {
    <form [formGroup]="CompanyForm.controls.CompanyPackagePricing">
      <div class="form-group">
        <label for="companyPackagePricing" class="form-label"
          >Fee Waiver Amounts</label
        >
        <input
          id="companyPackagePricing"
          type="number"
          class="form-control"
          formControlName="packageWaiverAmount"
        />
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  <div class="row w-100 justify-content-end">
    <div class="col-3">
      <button class="btn btn-danger" (click)="close()">Close</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
